import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import { Typography, Link } from '@material-ui/core';

const useStyles = makeStyles({
	footer: {
		backgroundColor: '#F8F8FA',
		borderTop: '1px solid #e6e8eb',
		padding: '48px 8% 40px 8%',
		'@media (max-width: 600px)': {
			padding: '32px 24px',
		},
	},
	columns: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: '40px',
		justifyContent: 'space-between',
	},
	column: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 160,
	},
	title: {
		color: '#54B5CF',
		fontFamily: 'Montserrat',
		fontSize: 18,
		fontWeight: 700,
		marginBottom: 14,
	},
	linkFooter: {
		color: '#444',
		fontFamily: 'Montserrat',
		fontSize: 15,
		fontWeight: 400,
		textDecoration: 'none',
		lineHeight: '34px',
		transition: 'color 0.2s ease',
		'&:hover': {
			color: '#54B5CF',
			textDecoration: 'none',
		},
	},
	socialRow: {
		display: 'flex',
		gap: 12,
		marginBottom: 18,
	},
	iconButton: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 42,
		height: 42,
		borderRadius: '50%',
		backgroundColor: '#54B5CF',
		transition: 'all 0.2s ease',
		'&:hover': {
			backgroundColor: '#0facc4',
			transform: 'translateY(-2px)',
		},
	},
	icons: {
		color: '#fff',
		fontSize: 24,
	},
	copyright: {
		color: '#8a9099',
		fontFamily: 'Montserrat',
		fontSize: 13,
		marginTop: 8,
		maxWidth: 280,
	},
});

const Footer = () => {
	const classes = useStyles();
	const year = new Date().getFullYear();

	return (
		<footer className={classes.footer}>
			<div className={classes.columns}>
				<div className={classes.column}>
					<Typography className={classes.title}>Pró-Fono</Typography>
					<Link href="https://minhafono.com.br/sobre" className={classes.linkFooter}>Sobre</Link>
					<Link href="https://profono.com.br/loja/" target="_blank" className={classes.linkFooter}>Produtos</Link>
					<Link href="https://profono.com.br/blog/" target="_blank" className={classes.linkFooter}>Blog</Link>
				</div>

				<div className={classes.column}>
					<Typography className={classes.title}>Sou Especialista</Typography>
					<Link href="/admin/dashboard/registro" className={classes.linkFooter}>Quero me cadastrar</Link>
				</div>

				<div className={classes.column}>
					<Typography className={classes.title}>Especialidade</Typography>
					<Link href="/profissionais-cards?category=fonoaudiologia" className={classes.linkFooter}>Fonoaudiologia</Link>
					<Link href="/profissionais-cards?category=psicologia" className={classes.linkFooter}>Psicologia</Link>
					<Link href="/profissionais-cards?category=pedagogia" className={classes.linkFooter}>Pedagogia</Link>
					<Link href="/profissionais-cards?category=fisioterapia" className={classes.linkFooter}>Fisioterapia</Link>
				</div>

				<div className={classes.column}>
					<Typography className={classes.title}>Redes Sociais</Typography>
					<div className={classes.socialRow}>
						<Link href="https://api.whatsapp.com/send?phone=5511991755257&text=" target="_blank" className={classes.iconButton}>
							<WhatsAppIcon className={classes.icons} />
						</Link>
						<Link href="https://www.facebook.com/profono/" target="_blank" className={classes.iconButton}>
							<FacebookIcon className={classes.icons} />
						</Link>
						<Link href="https://www.instagram.com/pro_fono/" target="_blank" className={classes.iconButton}>
							<InstagramIcon className={classes.icons} />
						</Link>
						<Link href="https://www.youtube.com/user/Profono" target="_blank" className={classes.iconButton}>
							<YouTubeIcon className={classes.icons} />
						</Link>
					</div>
					<Typography className={classes.copyright}>
						© Copyright {year} minhafono.com.br - Todos os direitos reservados
					</Typography>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
